import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';
import {Check} from "@sparkware/app-utils";

export class GameGroupFilter implements IGameFilter {
  constructor(private _gameGroupName: string | string[] ) {
  }

  get filterType(): FilterType {
    return FilterType.categoryFilter
  }

  applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {
    if(Check.isArray(this._gameGroupName)) {
      for(let i = 0; i < this._gameGroupName.length;i++){
        if (this._gameGroupName[i] === gameInfo.gameGroup){
          return true;
        }
      }
      return false;
    }

    return gameInfo.gameGroup === this._gameGroupName;
  }
}
